export default __webpack_public_path__ + "static/media/hs3.c5058ec7.png";